import {
  fetchUserProfile // From auth-utils, but conceptually part of profile logic
} from '@/context/auth/auth-utils'; 
import {
  fetchAndFormatMessages // Use the main fetch function from messageService
} from '@/services/messageService';
import {
  getAvailableTimeSlots // Use a function from bookingService
} from '@/services/bookingService';

// Mock IDs for testing - replace with actual test user/escort IDs if available
const TEST_USER_ID = 'user-test-id'; 
const TEST_PARTNER_ID = 'partner-test-id'; 
const TEST_CONVERSATION_ID = 'conversation-test-id'; 
const TEST_ESCORT_ID = 'escort-test-id'; 

/**
 * Test basic functionality of the profile service.
 */
export const testProfileService = async () => {
  console.log('Health Check: Testing profile service...');
  try {
    // Attempt to fetch a mock user profile
    const profile = await fetchUserProfile(TEST_USER_ID);
    // We don't strictly need a profile to exist, just that the call doesn't throw an unexpected error.
    // The function handles the 'not found' case internally.
    console.log(`Health Check: Profile service check completed (result may be null if test user ${TEST_USER_ID} doesn't exist).`);
    return { 
        success: true, 
        message: 'Profile service executed without throwing an error.' 
    };
  } catch (error) {
    console.error('Health Check Error: Testing profile service failed:', error);
    return { 
      success: false, 
      error: error instanceof Error ? error.message : 'Unknown error',
      message: 'Profile service test threw an error'
    };
  }
};

/**
 * Test basic functionality of the message service.
 */
export const testMessageService = async () => {
  console.log('Health Check: Testing message service...');
  try {
    // Attempt to fetch messages for a mock conversation
    await fetchAndFormatMessages(TEST_USER_ID, TEST_PARTNER_ID, TEST_CONVERSATION_ID);
    // Again, we mainly check if the call executes without unexpected errors.
    console.log(`Health Check: Message service check completed (may return empty array if test conversation ${TEST_CONVERSATION_ID} doesn't exist).`);
     return { 
        success: true, 
        message: 'Message service executed without throwing an error.' 
    };
  } catch (error) {
    console.error('Health Check Error: Testing message service failed:', error);
     return { 
      success: false, 
      error: error instanceof Error ? error.message : 'Unknown error',
      message: 'Message service test threw an error'
    };
  }
};

/**
 * Test basic functionality of the booking service.
 */
export const testBookingService = async () => {
  console.log('Health Check: Testing booking service...');
  try {
     // Attempt to get available slots for a mock date and escort
    await getAvailableTimeSlots(TEST_ESCORT_ID, new Date());
     console.log(`Health Check: Booking service check (getAvailableTimeSlots) completed.`);
     return { 
        success: true, 
        message: 'Booking service executed without throwing an error.' 
    };
  } catch (error) {
    console.error('Health Check Error: Testing booking service failed:', error);
     return { 
      success: false, 
      error: error instanceof Error ? error.message : 'Unknown error',
      message: 'Booking service test threw an error'
    };
  }
}; 